module.exports = __webpack_public_path__ + "img/no-show.c2edc9a2.svg";